import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarkerCutwiseGrade = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M48 48H0V0h48zM11.144 24 24 42.857 36.857 24 24.001 5.143z" })
});
export default SvgMarkerCutwiseGrade;
